import $ from 'jquery'

/**
 * Function that opens the mobile menu when clicking the hamburger
 */

export default function toggleArchiveTabs () {
  const tabs = $('.m__archive-tab-navigation__panel')
  let current = window.location.hash.split("#")[1] || $('.m__archive-tab-navigation__panel').first().attr('data-thesis')

  if (!tabs.length) {
    return
  }

  toggle(current);

  tabs.on('click', function(e) {
    e.preventDefault();
    let thesis = $(this).attr('data-thesis')
    toggle(thesis);
  })

  /**
   * Function that is called every time the hamburger element is clicked.
   */
  function toggle (thesis) {
    // remove active from panels and tabs
    $('.o__archive-cpt-list__panel').removeClass('panel_active').hide()
    $('.m__archive-tab-navigation__panel a').removeClass('active')
    $('.m__archive-tab-navigation__description').hide()

    // add active to current thesis
    $('#panel__' + thesis + ' a').addClass('active')
    $('#description__' + thesis).show()
    $('#o__archive-ideas-' + thesis).addClass('panel_active').show()
    window.location.hash = thesis;
  }
}
